/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const segmentPillDtoSchema = z.object({
  name: z.optional(z.string()),
  share: z.optional(z.string()),
});
